module.exports = __webpack_public_path__ + "static/media/nofeaturefeed.8e0995f5.svg";